import dayjs from 'dayjs'

const dateApiFormat = date => dayjs(date).format()

export default dateApiFormat
